export default __webpack_public_path__ + "static/media/complementary--caravans--g2.ce71e539.png";